import { render, staticRenderFns } from "./QuotationItem.vue?vue&type=template&id=502177d4&scoped=true&"
import script from "./QuotationItem.vue?vue&type=script&lang=js&"
export * from "./QuotationItem.vue?vue&type=script&lang=js&"
import style0 from "./QuotationItem.vue?vue&type=style&index=0&id=502177d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502177d4",
  null
  
)

export default component.exports